'use client';

import { createContext, useContext, useRef, type RefObject } from 'react';

type GlobalLayoutContextType = {
  correlationId: string;
  spaNavigationStart: RefObject<number | null>;
};

const GlobalLayoutContext = createContext<GlobalLayoutContextType>({
  correlationId: '',
  spaNavigationStart: { current: null }
});

export function GlobalLayoutProvider({
  children,
  correlationId
}: {
  children: React.ReactNode;
  correlationId: string;
}) {
  const spaNavigationStart = useRef<number | null>(null);

  return (
    <GlobalLayoutContext.Provider value={{ correlationId, spaNavigationStart }}>
      {children}
    </GlobalLayoutContext.Provider>
  );
}

GlobalLayoutProvider.displayName = 'GlobalLayoutProvider';

export function useCorrelationId() {
  return useContext(GlobalLayoutContext).correlationId;
}

export function useSpaNavigationTiming() {
  return useContext(GlobalLayoutContext).spaNavigationStart;
}
